import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

/* Impressions module functions */
(function($) {
    'use strict'

    /* Section media */
    gsap.registerPlugin(ScrollTrigger) 

    document.querySelectorAll( '.section-impressions' ).forEach( (section) => {
        let listElem = section.querySelectorAll('li')

        let tl = gsap.timeline({
            scrollTrigger: {
                trigger: section,
                start: 'top top+=25%',
                scrub: false,
                markers: false
            }
        })

        tl
            .addLabel('start')
            .to(
                listElem,
                { 
                    scale: () => 1,
                    duration: 3,
                    ease: 'elastic.out(1,0.3)',
                    stagger: 0.5,
                    repeat: -1,
                    repeatDelay: 15,
                    yoyo: true
                }
            )
            .addLabel('end')
    })
})(jQuery)